export default __webpack_public_path__ + "resources/icons/n130-9fd3.png";